<template>
  <div>
    <v-container>
      <h1 class="pb-4 primary--text font-weight-bold">
        {{
          isEditBooking
            ? $t("landlord.updateLandlord")
            : $t("bookings.createBooking")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <v-row align="center">
            <v-col cols="6">
              <ValidationProvider v-slot="{ errors }" name="Landlord">
                <v-autocomplete
                  outlined
                  dense
                  :error-messages="errors"
                  :items="landlordList"
                  :loading="$apollo.queries.getLandlords.loading"
                  :search-input.sync="searchKey"
                  :filter="filterLandlord"
                  :item-text="showFullName"
                  item-value="_id"
                  v-model="selectedLandlordId"
                  label="Select Landlord"
                  clearable
                >
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="property"
                rules="required"
              >
                <!-- <v-select :error-messages="errors" outlined dense :loading="dataLoading"
                :items="propertyListOfSelectedLandlord" item-text="nameEn" item-value="_id" no-data-text="No Properties"
                v-model="bookingsModel.property" @change="selectedUnit" label="Select Property">
                <template #label>
                  <span class="red--text"><strong>* </strong></span>Select Property
                </template>
              </v-select> -->
                <v-autocomplete
                  v-model="bookingsModel.property"
                  :error-messages="errors"
                  :items="
                    selectedLandlordId
                      ? propertyListOfSelectedLandlord
                      : propertyItems
                  "
                  item-text="nameEn"
                  item-value="_id"
                  :search-input.sync="propertySearch"
                  outlined
                  dense
                  :label="$t('bookings.property')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("bookings.property") }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  v-model="bookingsModel.unit"
                  :error-messages="errors"
                  :items="unitItems"
                  item-text="nameEn"
                  item-value="_id"
                  @change="selectedUnit"
                  outlined
                  dense
                  :label="$t('bookings.unit')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("bookings.unit") }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              class="py-0 d-flex justify-space-between"
            >
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  v-model="bookingsModel.customerId"
                  :error-messages="errors"
                  :items="customerItems"
                  item-text="firstName"
                  item-value="_id"
                  :search-input.sync="customerSearch"
                  outlined
                  full-width
                  dense
                  :label="$t('bookings.customer')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("bookings.customer") }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
              <v-btn
                class="rounded-md white--text"
                color="primary"
                depressed
                dense
                :to="{ name: 'Customer' }"
              >
                <v-icon size="20" left>mdi-plus</v-icon>
                {{ $t("customer.addCustomer") }}
              </v-btn>
            </v-col>
            <!-- <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
            <div>
              <v-btn
                class="py-0 custom-button text-none"
                depressed
                dense
                :to="{ name: 'Customer'}"
              >
                <v-icon size="20" left>mdi-plus</v-icon>
                {{ $t("customer.addCustomer") }}
              </v-btn>
            </div>
            </v-col> -->
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <!-- <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  disabled
                  :label="$t('bookings.price')"
                  type="number"
                  v-model="bookingsModel.rent"
                >
                </v-text-field>
              </ValidationProvider> -->
              <span v-if="bookingsModel.unit" class="font-weight-bold"
                >{{ $t("bookings.price") }}:{{ unitSelected.rent }}
                {{
                  unitSelected.property ? unitSelected.property.currency : ""
                }}</span
              >
            </v-col>
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('bookings.status')"
                  type="text"
                  v-model="bookingsModel.status"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
          </v-row>
          <v-row justify="space-around" class="py-6">
            <v-col cols="3" class="">
              <!-- <div class="d-flex justify-space-around"> -->
              <v-btn
                width="100%"
                class="rounded-lg white--text"
                color="primary"
                @click="onCancel"
              >
                {{ $t("common.cancel") }}
              </v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn
                width="100%"
                class="rounded-lg white--text"
                color="primary"
                type="submit"
                :loading="btnLoading"
                >{{
                  isEditBooking ? $t("common.update") : $t("common.save")
                }}</v-btn
              >
            </v-col>
            <!-- </div> -->
            <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { createBooking } from "../../methods/create_booking";
// import { updateBooking } from "../../methods/update_booking";
export default {
  data() {
    return {
      bookingsModel: {},
      reRender: 0,
      btnLoading: false,
      isError: null,
      customerSearch: "",
      unitSearch: "",
      propertySearch: "",
      unitItems: [],
      propertyItems: [],
      customerItems: [],
      rent: null,
      unitSelected: "",
      selectedLandlordId: "",
      selectedPropertyId: "",
      searchKey: "",
      selectedPropertyDetails: {},
      landlordList: [],
      propertyListOfSelectedLandlord: []
    };
  },
  computed: {
    ...mapGetters(["isEditBooking", "editBooking"])
  },
  watch: {
    selectedLandlordId(val) {
      this.dataLoading = true;
      this.$apollo
        .query({
          query: require("../../../promotions/api/queries/get_property_by_landlord_for_admin.graphql"),
          variables: {
            input: {
              limit: 0,
              skip: 0
            },
            landlordId: val
          }
        })
        .then(data => {
          this.dataLoading = false;
          this.propertyListOfSelectedLandlord = this.$format.cloneVariable(
            data.data.getPropertyByLandlordForAdmin.properties
          );
        });
    },
    searchKey() {
      this.$apollo.queries.getLandlords.refetch({
        input: {
          limit: 10,
          skip: 0
        },
        filter: {
          searchKey: this.searchKey || "",
          sortBy: "",
          sortDesc: false
        }
      });
    },
    isEditBooking: {
      handler() {
        if (this.isEditBooking) {
          this.bookingsModel = this.$format.cloneVariable(this.editBooking);
        } else {
          this.bookingsModel = {};
          this.rerender++;
        }
      },
      deep: true
    },
    customerSearch(val) {
      this.$apollo
        .query({
          query: require("@/user/api/queries/customer/search_customer_query.graphql"),
          variables: {
            input: {
              limit: 0,
              skip: 0
            },
            filter: {
              searchKey: val
            }
          }
        })
        .then(data => {
          if (data.data.searchCustomer.users)
            this.customerItems = data.data.searchCustomer.users;
        });
    },
    propertySearch(val) {
      this.$apollo
        .query({
          query: require("@/bookings/api/queries/get_properties.graphql"),
          variables: {
            input: {
              limit: 100,
              skip: 0
            },
            filter: {
              searchKey: val
            }
          }
        })
        .then(data => {
          if (data.data.getProperties.properties)
            this.propertyItems = data.data.getProperties.properties;
          console.log(this.propertyItems);
        })
        .catch(data => {
          console.log(data);
        });
    }
  },
  apollo: {
    unitSearch() {
      return {
        query: require("@/bookings/api/queries/get_units_under_property.graphql"),
        fetchPolicy: "no-cache",
        variables() {
          return { propertyId: this.bookingsModel.property };
        },
        result({ data }) {
          if (data.getUnitsUnderProperty)
            this.unitItems = data.getUnitsUnderProperty.filter(
              ({ _id }) => !this.bookedUnitList.some(x => x == _id)
            );
          console.log(this.unitItems);
        },
        skip() {
          return !this.bookingsModel.property;
        }
      };
    },
    getLandlords() {
      return {
        query: require("../../../landlord/api/queries/landlord_query.graphql"),
        variables: {
          input: {
            limit: 10,
            skip: 0
          },
          filter: {
            searchKey: this.searchKey || ""
          }
        },
        result({ data }) {
          this.landlordList = this.$format.cloneVariable(
            data.getLandlords.landlords
          );
        }
      };
    },
    getBookedUnitByPropertyId() {
      return {
        query: require("@/bookings/api/queries/get_booked_units.graphql"),
        fetchPolicy: "no-cache",
        variables() {
          return { propertyId: this.bookingsModel.property };
        },
        result({ data }) {
          if (data.getBookedUnitByPropertyId)
            this.bookedUnitList = data.getBookedUnitByPropertyId;
          console.log("---------------", this.bookedUnitList);
        },
        skip() {
          return !this.bookingsModel.property;
        }
      };
    }
  },
  methods: {
    filterLandlord(landlordInfo) {
      if (landlordInfo.user.active) {
        return true;
      }
      return false;
    },
    showFullName(item) {
      return item.user.firstName + " " + item.user.lastName;
    },
    selectedUnit(val) {
      this.$apollo
        .query({
          query: require("@/bookings/api/queries/get_unit_by_id.graphql"),
          variables: { id: val }
        })
        .then(data => {
          if (data.data.getUnitById) this.unitSelected = data.data.getUnitById;
        });
    },
    async onSave() {
      this.btnLoading = true;
      const variables = {
        customerId: this.bookingsModel.customerId,
        bookinginput: {
          property: this.bookingsModel.property,
          unit: this.bookingsModel.unit
        }
      };
      if (!this.isEditBooking) {
        createBooking(
          variables,
          {
            limit: 50,
            skip: 0
          },
          {
            searchKey: ""
          }
        ).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("refetchBookings");
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      }
      // else {
      //   input.user.password = "";
      //   const updateData = {
      //     id: input._id,
      //     input: {
      //     }
      //   };
      //   updateBooking(updateData).then(data => {
      //     if (data.data) {
      //       this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      //       this.$root.$emit("snackbar", {
      //         snackbar: true,
      //         text: this.$t("common.updateSuccess"),
      //         color: "green"
      //       });
      //       this.btnLoading = false;
      //       this.$store.commit("IS_EDIT_BOOKING", false);
      //     } else {
      //       if (data.graphQLErrors.length) {
      //         this.btnLoading = false;
      //         this.isError = data.graphQLErrors[0].message;
      //       }
      //     }
      //   });
      // }
    },
    onCancel() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$store.commit("IS_EDIT_BOOKING", false);
    },
    openRightSideDrawer() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  }
};
</script>

<style></style>
